import { ITruong } from "../../../model/respone/category/ITruong";
import { IActionTypeBase } from "../IActionTypeBase";

export enum eTruongActionTypeIds {
    LOAD_START = "TRUONG_LOAD_START",
    LOAD_SUCCESS = "TRUONG_LOAD_SUCCESS",
    LOAD_ERROR = "TRUONG_LOAD_ERROR"
}
export interface ITruongLoadStart extends IActionTypeBase<eTruongActionTypeIds.LOAD_START, undefined> { }
export interface ITruongLoadSuccess extends IActionTypeBase<eTruongActionTypeIds.LOAD_SUCCESS, ITruong[]> { }
export interface ITruongLoadError extends IActionTypeBase<eTruongActionTypeIds.LOAD_ERROR, string | undefined> { }

export type ITruongActionTypes = ITruongLoadStart | ITruongLoadSuccess | ITruongLoadError